import { useContext, useEffect, useRef, useState } from 'react'
import { CamelCaseWithSpaces, formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, LogInUserID, origin, transformNameOfCol, typewatch, CustomParseSafeHtml, GetAllSchoolsByLocation, trackingHandle, getTypeWatchDelay, shipStationUrlTrack } from '../../JS/Common';
import { ApiCmnHeadersGetCall, ApiGetCall, ApiGetCDNData, ApiGetHeaders, ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { UserContext } from '../../App';
import Deletepopup from '../../Components/Deletepopup';
import jinja from "jinja-js";
import html2pdf from "html2pdf.js";
import CustomizationPopup from '../../Components/CustomizationPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faPaperPlane, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import SignatureCanvas from "react-signature-canvas";
import PageHead from '../../Components/PageHead';
import Tab from '../../Components/Tab';
import Popup from '../../Components/Popup';
import AlertPopup from '../../Components/AlertPopup';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import { log } from '../../JS/Logger';
import { useSelector } from 'react-redux';
import CustomFontAwesomeIcon from '../../Components/CustomFontAwesomeIcon';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import { useStickyAction } from '../../Hooks';

export function AdminBilling() {
    const { error_text_color, succes_text_color, inProgress_text_color, show_part_order_module,
        organization, no_organization_found, adminCallNode
    } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const sigCanvasForPackedBy = useRef({});
    const [SchoolId, setSchoolId] = useState(null)
    const [AllInvoiceData, setAllInvoiceData] = useState([]);
    const [AdminInvoiceParams, setAdminInvoiceParams] = useState({
        BatchId: '',
        searchString: '',
        subTotal: 0,
        sendreceipt: false,
        InvoiceNo: '',
        TransactionId: '',
        uploadReceipt: false,
        flagforuploadReceipt: 2,
        fileName: '',
        file: null,
        base64String: '',
        Notes: '',
        SortbyFlag: 'desc',
        sendSchoolid: null,
    });
    const [GridTabs, setGridTabs] = useState({
        BatchesTabs: "active",
        PastBatchesTabs: '',
        PartsOrdersTabs: '',
    });
    const [SelectedFileName, setSelectedFileName] = useState([]);
    const [NewAlerts, setNewAlerts] = useState("");

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = AllInvoiceData?.length > 0;
    const { UserData } = useContext(UserContext);
    const [deletePopup, setDeletePopup] = useState(false);
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [ShowCreateBatchButton, setShowCreateBatchButton] = useState(false)
    const [selectedIdsAll, setSelectedIdsAll] = useState([]);
    const [SelectedItems, setSelectedItems] = useState([]);
    const [DeliverBatchModal, setDeliverBatchModal] = useState(false)
    const [itemID, setItemID] = useState('')
    const [FlagForItem, setFlagForItem] = useState('')
    const [PaymentLink, setPaymentLink] = useState('')
    const [linkFileName, setlinkFileName] = useState('')
    const [sendInvoiceDoc, setsendInvoiceDoc] = useState('')

    const [error, setError] = useState('');
    const [pdfError, setPdfError] = useState('');

    const [SortKey, setSortKey] = useState(null)
    const [SignatureDataForPackedBy, setSignatureDataForPackedBy] = useState('')
    const [signatureModal, setSignatureModal] = useState(false)

    const [MarkasPaidPopup, setMarkasPaidPopup] = useState(false)
    const [markAsPaidData, setMarkAsPaidData] = useState({
        batchId: "",
        invoiceId: "",
        chequeNo: "",
        schoolId: "",
    });
    const [markaspaidflag, setMarkAsPaidFlag] = useState(0);
    const [AllSchool, setAllSchool] = useState([])
    const [NetSuiteModal, setNetSuiteModal] = useState(false)
    const [NetSuiteData, setNetSuiteData] = useState([])
    const [RequiredFieldsPopup, setRequiredFieldsPopup] = useState(false)
    const [requiredData, setRequiredData] = useState({
        customerid: '',
        subsidiary: '',
        schoolid: '',
        batchid: '',
        invoiceId: '',
    })
    const [partsOrderBillFlag, setPartsOrderBillFlag] = useState(1);
    const [modals, setModals] = useState({
        showFinalizeBilling: false,
        showBilledBatchOrder: false
    });
    const [BatchData, setBatchData] = useState([]);
    const [sortingDetails, setSortingDetails] = useState({
        column: null,
        sortFlag: "desc",
    });
    const [selectedBillingItems, setSelectedBillingItems] = useState([]);
    const [isAllChecked, setAllChecked] = useState(false);
    const [PartsOrderFile, setPartsOrderFile] = useState({
        fileName: "",
        fileBase64String: ""
    });
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const ExcludeVar = hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_VAR);
    const onlyRepairTech = hasRoleAccess(effectiveRole, RoleEnum.ONLY_REPAIR_TECH);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    useEffect(() => {
        ApiGetHeaders(32, setColumnNames)
        if (hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR)) {
            ApiGetCall(`/schools/vendor-schools?vendorId=${LogInUserID}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs?.allSchool?.length != 0) {
                        const sortedSchools = responseRs?.allSchool?.sort((a, b) =>
                            a?.name?.localeCompare(b?.name)
                        );
                        setAllSchool(sortedSchools)
                    }
                }
            });
        } else {
            GetAllSchoolsByLocation({ setAllSchool })
        }

    }, []);
    useEffect(() => {
        if (GridTabs.BatchesTabs == 'active') {
            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, SortKey || null, 1, false)
        } else if (GridTabs.PastBatchesTabs == 'active') {
            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, SortKey || null, 2, false)
        } else {
            GetPartOrdersWithBilling(partsOrderBillFlag, SchoolId, null, sortingDetails.column, sortingDetails.sortFlag, null, false);
        }
    }, [currentPage, LimitForPagination]);

    useEffect(() => {
        if (selectedIdsAll.length === 0) {
            setSelectedItems([]);
            setShowCreateBatchButton(false);
            return;
        }

        const idAndSchoolArray = selectedIdsAll.map(({ id, schoolId, invoice_id, cheque_no }) => ({
            id,
            schoolId,
            invoice_id,
            cheque_no,
        }));

        setSelectedItems(idAndSchoolArray);
        setShowCreateBatchButton(true);
    }, [selectedIdsAll]);

    useEffect(() => {
        if (AllInvoiceData?.length > 0) {
            const allChecked = AllInvoiceData?.every((item) =>
                selectedBillingItems.some((device) => device.id === item.id)
            );
            setAllChecked(allChecked);
        }
    }, [AllInvoiceData, selectedBillingItems, currentPage, LimitForPagination]);

    async function GetAdminInvoiceData(id, searchString, sortkey, GridFlagForBilling, toggleSort) {
        setSchoolId(id ? id : '0')
        if (searchString == undefined || searchString == "") {
            searchString = null;
        }
        if (sortkey == undefined || sortkey == "") {
            sortkey = null;
        }
        if (id == 0) {
            id = null
        }
        if (toggleSort && sortkey != null) {
            if (AdminInvoiceParams.SortbyFlag == "desc") {
                AdminInvoiceParams.SortbyFlag = "asc";
            } else {
                AdminInvoiceParams.SortbyFlag = "desc";
            }
        }
        var joinedString = null;
        if (columnNames.length > 0) {
            var joinedString = columnNames.join('~');
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/billing/batches/all-data?userId=${LogInUserID}&schoolId=${id}&search=${searchString}&sortBy=${sortkey}&sortByOrder=${AdminInvoiceParams.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&gridId=${GridFlagForBilling}&panelId=0&data=${joinedString}`).then((result) => {
                setLoading(false);
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.total)
                    if (responseRs.tickets.length != 0) {
                        setAllInvoiceData(responseRs.tickets);
                    } else {
                        setAllInvoiceData([]);
                    }
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }
    function handleChange(e) {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        const { isFileValid, validationMsg } = ValidateFile(selectedFile, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            setAdminInvoiceParams({ ...AdminInvoiceParams, fileName: "", file: "", base64String: "" });
            setSelectedFileName("")
            setError(validationMsg);
            e.target.value = "";
            return;
        }
        setAdminInvoiceParams({ ...AdminInvoiceParams, fileName: selectedFile.name, file: selectedFile });
        setSelectedFileName(selectedFile.name);
        setError("");
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = () => {
            setAdminInvoiceParams({ ...AdminInvoiceParams, base64String: reader.result })
        };
        reader.onerror = (error) => {
            log.error("Error: ", error);
        };
        e.target.value = "";
    };
    function handleSubmit(e) {
        e.preventDefault();
    };
    async function SubmitInvoicePaymentCheck() {
        const isValid = CheckValidation({ formID: "CheckSendReceiptBody" });
        if (!isValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            receipt: AdminInvoiceParams.base64String,
            schoolId: AdminInvoiceParams.sendSchoolid,
            invoiceId: AdminInvoiceParams.InvoiceNo,
            batchId: AdminInvoiceParams.BatchId,
            flag: AdminInvoiceParams.flagforuploadReceipt,
            invoiceStatus: 1,
            notes: AdminInvoiceParams.Notes,
            userID: LogInUserID
        });
        await ApiPostCall(`${adminCallNode}/invoices/payment-check`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = result;
                setAdminInvoiceParams({ ...AdminInvoiceParams, sendreceipt: false, Notes: '', BatchId: '', uploadReceipt: false, flagforuploadReceipt: 2 })
                if (responseRs == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'Payment Processed Successfully'} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        if (GridTabs.BatchesTabs == 'active') {
                            GetAdminInvoiceData(SchoolId, null, null, 1, false)
                        } else {
                            GetAdminInvoiceData(SchoolId, null, null, 2, false)
                        }
                    }, 2000);

                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }

    async function ExtraDocument(FedExQr) {
        ApiGetCDNData("/" + FedExQr, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "ShipStation_Label"; //
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        });
    };
    async function InvoicePdf(Invoice) {
        ApiGetCDNData("/" + Invoice, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    };
    async function DeleteBatch() {
        setLoading(true);
        var raw = JSON.stringify({
            flag: 2,
            batchId: AdminInvoiceParams.BatchId,
            schoolId: AdminInvoiceParams.sendSchoolid
        });
        await ApiPostCall(`${adminCallNode}/billing/batches/delete`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setDeletePopup(false);
                const ResponseRs = JSON.parse(result);
                if (ResponseRs?.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={ResponseRs?.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        if (GridTabs.BatchesTabs == 'active') {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 1, false)
                        } else {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 2, false)
                        }
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={ResponseRs?.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function PrintPackingList(batchid) {
        setLoading(true)
        fetch(`${origin}/PackingListForAdminBatch.html`)
            .then(response => response.text())
            .then(templateText => jinja.compile(templateText))
            .then(template => {
                ApiCmnHeadersGetCall("/schools/billing-batches/print-list?batchId=" + batchid)
                    .then(response => JSON.parse(response))
                    .then(data => {
                        const formattedDate = new Date(data.createdAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        });
                        const rendered = template.render({ data, formattedDate });
                        const pdfContent = CustomParseSafeHtml(rendered, false)
                        pdfContent.style.padding = '20px';
                        html2pdf().from(pdfContent).save();
                        setLoading(false)
                    })
                    .catch(error => {
                        setLoading(false)
                        log.error('Error loading data from API', error);
                    });
            })
            .catch(error => {
                setLoading(false)
                log.error('Error loading template', error);
            });
    }
    const handleSortClick = (item) => {
        if (item == 'deviceCount') {
            item = 'batch_log_count'
        }
        if (item == "InvoiceNum") {
            item = "invoice_id"
        }
        if (item !== 0) {
            if (GridTabs.BatchesTabs == 'active') {
                GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString, item, 1, true)
            } else {
                GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString, item, 2, true)
            }
            setSortKey(item)
        }
    };
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "Name": (
                ExcludeVar ?
                    <span className="cursor-pointer" title='Show Batch Details' onClick={(e) => { navigate('/ticket-history?id=' + item?.id, { state: { SchoolId: item?.school_id, SchoolAdminFlag: 1 } }) }}>
                        <u>{item?.name || '-'}</u>
                    </span>
                    :
                    <span>
                        {item?.name || '-'}
                    </span>
            ),
            "TrackingNum": (
                <span>
                    {onlyRepairTech ?
                        (item?.tracking_num != null ? item?.tracking_num : <>-</>)
                        :
                        (item?.tracking_num != null ? <u className='cursor-pointer' onClick={(e) => shipStationUrlTrack(item?.tracking_url)}>{item?.tracking_num}</u> : <>-</>)
                    }
                </span>
            ),
            "deviceCount": item?.batch_log_count || '-',
            "ReturnLocation": item?.return_building_name || '-',
            "InvoiceNum": item?.invoice_code == null ? <>-</> : <div>#{item?.invoice_code}</div>,
            "Amount": item?.amount == null ? <>0</> : <div>${item?.amount}</div>,
            "created_at": item?.created_at ? formatDateToUsaMMDDYYYY(item?.created_at) : '-',
            "Location":
                <span>
                    {item.batch_location_flag == 0 ?
                        <>{item.batch_location || '-'}</>
                        :
                        <span className='blueText'>{item.batch_location || '-'}</span>
                    }

                </span>,

            "Batch_Status": (
                <span>
                    {item?.type == 1 ?
                        <span >Pending Invoice</span>
                        : item?.type == 2 ?
                            <span >$0 Invoice</span>
                            : item?.type == 3 ?
                                <span >Finalized</span>
                                : item?.type == 4 ?
                                    <span >Invoice Sent</span>
                                    : item?.type == 5 ?
                                        <span >Invoice Received</span>
                                        :
                                        <span >Completed</span>
                    }
                </span>
            ),
            "Notes": <div className="note-wrap">{item.notes || '-'}</div>,
        };

        return contentMap[columnName] || null;
    }
    function handleHeaderCheckboxChange(e, ticketFlag) {
        setShowCreateBatchButton(true);
        const isChecked = e.target.checked;
        if (ticketFlag === "all") {
            if (isChecked) {
                const currentPageMapped = currentPageType3Items.map((item) => ({
                    id: item.id,
                    schoolId: item.schoolId,
                    invoice_id: item.invoice_id,
                    cheque_no: item.cheque_no,
                }));
                setSelectedIdsAll(prev => [
                    ...prev.filter(s => !currentPageType3Items.some(i => i.id === s.id)),
                    ...currentPageMapped
                ]);
            } else {
                setSelectedIdsAll(prev =>
                    prev.filter(s => !currentPageType3Items.some(i => i.id === s.id))
                );
            }
        }
    }
    function handleCheckboxChange(e, ticketFlag, ID, schoolId, invoice_id, cheque_no) {
        const isChecked = e.target.checked;
        setShowCreateBatchButton(true);

        if (ticketFlag === "all") {
            setSelectedIdsAll((prevIds) => {
                if (isChecked) {
                    const alreadyExists = prevIds.some((item) => item.id === ID);
                    if (!alreadyExists) {
                        return [...prevIds, { id: ID, schoolId, invoice_id, cheque_no }];
                    }
                    return prevIds;
                } else {
                    return prevIds.filter((item) => item.id !== ID);
                }
            });
        }
    }
    async function DeliverBatchCall() {
        var vArray = [];
        var vjson = {};
        vjson['uuid'] = itemID;
        vArray.push(vjson)
        var paymentlink = null;

        if (PaymentLink) {
            if (!PaymentLink.startsWith("https://") && !PaymentLink.startsWith("http://")) {
                paymentlink = "https://" + PaymentLink;
            } else {
                paymentlink = PaymentLink;
            }
        }
        var batcharray = [];
        {
            FlagForItem != 1 &&
                SelectedItems?.map((item) => {
                    var selectedjson = {};
                    selectedjson['uuid'] = item.id;
                    batcharray.push(selectedjson);
                })
        }

        var raw = JSON.stringify({
            batchIds: FlagForItem == 1 ? vArray : batcharray,
            flag: 1,
            userId: LogInUserID,
            linkForPayment: paymentlink,
            document: sendInvoiceDoc,
        });
        setLoading(true)
        await ApiPostCall(`${adminCallNode}/billing/deliver-receive-btn`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setDeliverBatchModal(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Invoice Sent Successfully"} />);
                    setTimeout(() => {
                        if (GridTabs.BatchesTabs == 'active') {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 1, false)
                        } else {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 2, false)
                        }
                        setSelectedIdsAll([])
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }
    function handlePdfFileForInvoiceLink(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "pdf", maxSizeMB: 5 });
        if (!isFileValid) {
            setlinkFileName("");
            setsendInvoiceDoc("");
            setPdfError(validationMsg);
            e.target.value = ""
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            setlinkFileName(file.name);
            setsendInvoiceDoc(base64String);
            setPdfError("");
        };
        reader.readAsDataURL(file);
        e.target.value = ""
    };
    const clearSignatureForPackedBy = () => {
        if (SignatureDataForPackedBy != null) {
            setSignatureDataForPackedBy(null)
        } else {
            sigCanvasForPackedBy.current.clear();
        }
    };
    async function SaveSignatureCall() {
        var signatureBase64 = null;
        if (SignatureDataForPackedBy == null) {
            signatureBase64 = sigCanvasForPackedBy.current.isEmpty() ? null : sigCanvasForPackedBy.current.getTrimmedCanvas().toDataURL("image/png");
        } else {
            signatureBase64 = SignatureDataForPackedBy
        }
        setLoading(true);
        var raw = JSON.stringify({
            batchId: null,
            schoolId: AdminInvoiceParams.sendSchoolid,
            batchPackerSignature: null,
            batchReceiverSignature: null,
            adminBatchId: AdminInvoiceParams.BatchId,
            adminBatchDeliverSignature: signatureBase64,
            adminBatchReceiverSignature: null,
            flag: 1,
            userId: LogInUserID
        });
        await ApiPostCall("/schools/batches/add-signature", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setSignatureModal(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Signature Added Successfully"} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        if (GridTabs.BatchesTabs == 'active') {
                            GetAdminInvoiceData(SchoolId, null, null, 1, false)
                        } else {
                            GetAdminInvoiceData(SchoolId, null, null, 2, false)
                        }
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        });
    }
    function handleSearchChange(e) {
        setAdminInvoiceParams({ ...AdminInvoiceParams, searchString: e.target.value });
        setCurrentPage(1);
        GridTabs.BatchesTabs == 'active' ?
            GetAdminInvoiceData(SchoolId, e.target.value, null, 1, false) :
            GridTabs.PastBatchesTabs == 'active' ?
                GetAdminInvoiceData(SchoolId, e.target.value, null, 2, false) :
                GetPartOrdersWithBilling(partsOrderBillFlag, SchoolId, e.target.value, null, sortingDetails.sortFlag, null, false)
    }
    function handleTabClick(tabType, partsOrderFlag) {
        setSchoolId('0');
        setCurrentPage(1);
        setSelectedIdsAll([]);
        setSelectedBillingItems([]);
        if (tabType == "current") {
            setGridTabs({ ...GridTabs, BatchesTabs: "active", PastBatchesTabs: '', PartsOrdersTabs: '' });
            GetAdminInvoiceData(null, null, null, 1, false);
        } else if (tabType == "past") {
            setGridTabs({ ...GridTabs, BatchesTabs: "", PastBatchesTabs: 'active', PartsOrdersTabs: '' });
            GetAdminInvoiceData(null, null, null, 2, false)
        } else if (tabType == "partsorders") {
            setAllInvoiceData([]);
            setPartsOrderBillFlag(partsOrderFlag);
            setGridTabs({ ...GridTabs, BatchesTabs: "", PastBatchesTabs: '', PartsOrdersTabs: 'active' });
            GetPartOrdersWithBilling(partsOrderFlag, null, null, null, "desc", null, false)
        }
    }
    async function GetBatchDetailsById(id) {
        setLoading(true);
        typewatch(async function () {
            var result = await ApiGetCall(`/part-orders/billed-batch-details?uuid=${id}`);
            if (!result || result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
                return;
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setBatchData(responseRs.msg.part_order_items.length ? responseRs.msg : [])
            }
        }, 500);
    };

    async function GetPartOrdersWithBilling(GridFlagForBilling, sid, searchString, columnName, sFlag, Lid, toogleSort) {
        if (searchString == undefined || searchString?.trim() == "") {
            searchString = null;
        } else {
            searchString = searchString?.trim() || null;
        }

        if (!Lid) {
            Lid = null
        }

        if (sid == undefined || sid == "" || sid == "0") {
            sid = null;
        }

        if (columnName == undefined || columnName == "") {
            columnName = null;
        }
        if (toogleSort) sFlag = sFlag == "asc" ? "desc" : "asc" || "desc";
        setSortingDetails({ ...sortingDetails, column: columnName, sortFlag: sFlag })
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/part-orders/fulfillments?flag=${GridFlagForBilling}&locationId=${Lid}&schoolId=${sid}&search=${searchString}&sortBy=${columnName}&sortByOrder=${sFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                setLoading(false);
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.msg.total)
                    if (responseRs.msg.data.length != 0) {
                        setAllInvoiceData(responseRs.msg.data);
                    } else {
                        setAllInvoiceData([]);
                    }
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }
    async function FinalizeBatchBilling() {
        const uniqueSchoolIds = [...new Set(selectedBillingItems.map((item) => item.school_id))];

        if (uniqueSchoolIds.length > 1) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={`Only 1 ${organization} at a time. More than 1 ${organization} are not allowed!`} />)
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
                setModals({ ...modals, showFinalizeBilling: false });
            }, 3000);
            return;
        }
        var raw = JSON.stringify({
            "partOrderIds": selectedBillingItems.map(item => item.id),
            "invoiceFile": null,
            "schoolId": uniqueSchoolIds[0],
            "userId": LogInUserID
        })
        setLoading(true);
        await ApiPostCall("/part-orders/update-to-billed", raw).then((result) => {
            if (!result || result == undefined || result == "" || result == "Something Went Wrong") {
                setLoading(false)
                alert("Something went wrong");
            } else {
                setLoading(false)
                setNewAlerts(<AlertsComp show={true} variant="success" msg={"Parts Order Billing Finalized Successfully!"} />)
                setTimeout(() => {
                    setSchoolId(null);
                    setAdminInvoiceParams({ ...AdminInvoiceParams, searchString: null });
                    setSortingDetails({ ...sortingDetails, column: null, sortFlag: "desc" });
                    setModals({ ...modals, showFinalizeBilling: false, showBilledBatchOrder: false });
                    setPartsOrderBillFlag(2);
                    setSelectedBillingItems([]);
                    setNewAlerts(<AlertsComp show={false} />);
                    setCurrentPage(1);
                    GetPartOrdersWithBilling(2, null, null, null, "desc", null, false);
                }, 2000)
            }
        })
    }
    const sendreceiptBody = (
        <div className='parent' id="CheckSendReceiptBody">
            <div className=" col-md-12 row">
                <div className="col-md-12">
                    <div className="fw-600">Transaction ID :{AdminInvoiceParams.TransactionId}</div>
                </div>
                <div className="col-md-12 d-flex align-item-center justify-content-between py-3">
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name='ParentalCoverage' value='PaymentSuccess' id="SuccessYes" onChange={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, uploadReceipt: true, flagforuploadReceipt: 1 })} onClick={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, uploadReceipt: true, flagforuploadReceipt: 1 })} />
                        <label className="form-check-label">
                            Payment Success
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" defaultChecked type="radio" name='ParentalCoverage' value='PaymentWaiting' id="WaitingNo" onChange={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, uploadReceipt: false, flagforuploadReceipt: 2 })} onClick={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, uploadReceipt: false, flagforuploadReceipt: 2 })} />
                        <label className="form-check-label">
                            Payment Waiting
                        </label>
                    </div>
                </div>
                <div className=" mt-1">
                    <textarea placeholder="Notes*" rows="2" className="form-control" value={AdminInvoiceParams.Notes} required onChange={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, Notes: e.target.value })} ></textarea>
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
            </div>

            {AdminInvoiceParams.uploadReceipt == true && (
                <div className="col-md-12 row mt-2">
                    <div className="col-md-12 fw-600 py-12">Upload Invoice Receipt</div>
                    <div className="col-md-12">
                        <form onSubmit={handleSubmit}>
                            <input type="file" label="Image" name="myFile" accept="image/*" id="UploadFileId" onChange={handleChange} />
                            <label className='ImportInventoryBtnForAdminInvoice' htmlFor="UploadFileId"> Chooes file
                                <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                            </label>
                            {SelectedFileName && <label id="ImportInventoryStudentText" className="ps-2 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)' }}>{SelectedFileName}</label>}
                            {error?.trim() != "" && <label className='redText'>{error}</label>}
                        </form>
                    </div>

                </div>
            )}
        </div>
    )
    const delievermodal = (
        <div id="LinkDiv" className="parent">
            <div className='col-12 text-center pt-2'>
                <div className='FormLabel text-start'>Enter Payment Link</div>
                <div className='col-md-12 py-2'>
                    <div className="input-group ">
                        <span className="input-group-text">https://</span>
                        <input type="text" autoComplete='off' className="form-control" name='paymentlink'
                            value={PaymentLink} onChange={(e) => setPaymentLink(e.target.value)} />
                    </div>
                </div>
            </div>
            <div className="col-md-12 pt-3">
                <div className='FormLabel text-start'>Enter Invoice Document</div>
                <div className="col-md-12 py-2">
                    <input type="file" label="img" id="UploadFileId" name="myFile" accept="application/pdf" onChange={(e) => handlePdfFileForInvoiceLink(e)} />
                    <label className="ImportInventoryBtn col-md-8" htmlFor="UploadFileId" style={{ color: "#909091" }}>
                        Choose File
                    </label>
                    <input type="file" className="col-md-4 col-9 ImportInventoryBtn" />
                    <label className="ImportInventoryBtn1 text-center col-md-4 col-3" htmlFor="UploadFileId" style={{ backgroundColor: "var(--primary-color)", color: "white", height: "40px", }}>
                        Browse
                    </label>
                </div>
                {linkFileName &&
                    <label className="ps-3 mt-1 d-flex" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{linkFileName} </label>}
                {pdfError?.trim() != '' && <label className='redText'>{pdfError}</label>}
            </div>

        </div>
    )
    const signaturemodalbody = (
        <div className="col-12 py-1">
            <div className="greyBox">
                <div className='fw-600 font-15 text-center'>Packed By Signature:</div>
                <div className='mt-2 text-center'>
                    {SignatureDataForPackedBy ? (
                        <img src={SignatureDataForPackedBy} alt="Packed By Signature" />
                    ) : (
                        <SignatureCanvas
                            ref={sigCanvasForPackedBy}
                            canvasProps={{ width: 430, height: 100, className: "signatureCanvas" }}
                        />
                    )}
                </div>
                <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForPackedBy}><u>Clear</u></label></div>
            </div>
        </div>
    )
    async function DownloadCSV(batchid, customerid, subsidiary, schoolid, flag, invoiceid) {
        setRequiredData({ ...requiredData, customerid: customerid, batchid: batchid, subsidiary: subsidiary, schoolid: schoolid, invoiceId: invoiceid })
        if (flag != 2) {
            if (!customerid || !subsidiary) {
                setRequiredFieldsPopup(true);
                return;
            }
        }
        setLoading(true);
        await ApiGetCall(`${adminCallNode}/billing/batches/export?batchId=${batchid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.length > 0) {
                    Download(responseRs, invoiceid);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={"No data available for download"} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    const Download = (CsvDataForUser, invoiceId) => {
        const csvContent = [];
        const buildingMap = [];
        CsvDataForUser?.forEach((user) => {
            const rowData = {
                'Account Number': user?.account_number,
                'Acct ID': user?.account_code,
                'Line ID': user?.line_code,
                'External ID': user?.external_code,
                'Date': user?.date ? formatDateToMMDDYYYY(user?.date) : '-',
                'Document Number Assigned in Upload': user.document_number,
                'PO#': user.po,
                'Customer ID': user?.customer_code,
                'Customer': user?.customer,
                'Item: Internal ID': user?.internal_code,
                'Item: Name': user?.internal_name,
                'Quantity': user.quantity,
                'Rate': user?.rate,
                'Amount (Net)': user?.amount,
                'Class': user?.class,
                'Description': user?.description,
                'Price Level': user?.price_level,
                'Status': user?.status,
                'Subsidiary': user?.subsidiary,
                'Location': user?.netsuite,
                'Active Coverage Type': user?.active_coverage_type,
                'Repair Type': user?.repair_type,
            };
            buildingMap.push(rowData);
        });

        const headers = ['Account Number', 'Acct ID', 'Line ID', 'External ID', 'Date',
            'Document Number Assigned in Upload', 'PO#', 'Customer ID', 'Customer', 'Item: Internal ID',
            'Item: Name', 'Quantity', 'Rate', 'Amount (Net)', 'Class', 'Description',
            'Price Level', 'Status', 'Subsidiary', 'Location', 'Active Coverage Type', 'Repair Type'
        ];
        csvContent.push(headers);
        buildingMap.forEach((rowData) => {
            const values = Object.values(rowData).map(value => {
                const strVal = value != null ? value.toString() : '';
                if (strVal.includes(',') || strVal.includes('"') || strVal.includes('\n')) {
                    const escaped = strVal.replace(/"/g, '""');
                    return `"${escaped}"`;
                }
                return strVal;
            });

            csvContent.push(values);
        });
        csvContent.push([]);
        const csvString = csvContent.map((row) => row.join(',')).join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Batch-${invoiceId}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    function handleSetSchoolId(id) {
        setCurrentPage(1);
        setSchoolId(id);
        if (GridTabs.BatchesTabs == 'active') {
            GetAdminInvoiceData(id, AdminInvoiceParams.searchString || null, null, 1, false)
        } else if (GridTabs.PastBatchesTabs == 'active') {
            GetAdminInvoiceData(id, AdminInvoiceParams.searchString || null, null, 2, false)
        } else if (GridTabs.PartsOrdersTabs == 'active') {
            GetPartOrdersWithBilling(partsOrderBillFlag, id, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, sortingDetails.sortFlag, null, false)
        }
    }
    async function SaveMarkAsPaidBatch() {
        if (markaspaidflag == 2) {
            var combineArray = [];
            var vjson = {};
            vjson['batchId'] = markAsPaidData.batchId ? markAsPaidData.batchId : null;
            vjson['invoiceId'] = markAsPaidData.invoiceId ? markAsPaidData.invoiceId : null;
            vjson['chequeNo'] = markAsPaidData.chequeNo ? markAsPaidData.chequeNo : null;
            vjson['schoolId'] = markAsPaidData.schoolId ? markAsPaidData.schoolId : null;
            vjson['flag'] = 1;
            vjson['UserID'] = LogInUserID;
            vjson['BatchReceiverSignature'] = null;
            vjson['AdminFlag'] = 1;
            combineArray.push(vjson);
        } else {
            var selecteditemarray = [];
            {
                SelectedItems?.map((item) => {
                    var selectedjson = {};
                    selectedjson['batchId'] = item.id || null;
                    selectedjson['invoiceId'] = item.invoice_id || null;
                    selectedjson['chequeNo'] = item.cheque_no || null;
                    selectedjson['schoolId'] = item.schoolId || null;
                    selectedjson['flag'] = 1;
                    selectedjson['UserID'] = LogInUserID;
                    selectedjson['BatchReceiverSignature'] = null;
                    selectedjson['AdminFlag'] = 1;
                    selecteditemarray.push(selectedjson)
                })
            }
        }
        var raw = JSON.stringify({
            batches: markaspaidflag == 2 ? combineArray : selecteditemarray
        });
        setLoading(true);
        await ApiPostCall("/schools/invoices/payment-details", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setMarkasPaidPopup(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"The batch has been marked as paid successfully."} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        if (GridTabs.BatchesTabs == 'active') {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 1, false)
                        } else {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 2, false)
                        }
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });

    }
    const requiredfieldmodalbody = (
        <div className='row parent' id="requiredFieldsDiv">
            <label>Some required fields are missing:</label>
            <label>Please enter the missing information below to proceed with the CSV export.</label>
            <div className='col-12 py-2'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>NetSuite Customer ID<label className='redText'>*</label></div>
                <input className="form-control" autoComplete='off' name='building' required type='number'
                    value={requiredData.customerid}
                    onChange={(e) => setRequiredData({ ...requiredData, customerid: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 py-2'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Subsidiary<label className='redText'>*</label></div>
                <input className="form-control" autoComplete='off' name='building' required
                    value={requiredData.subsidiary}
                    onChange={(e) => setRequiredData({ ...requiredData, subsidiary: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
        </div>
    )
    async function SaveRequiredFields() {
        var isFormValid = CheckValidation({ formID: 'requiredFieldsDiv' });
        if (!isFormValid) return;
        var raw = JSON.stringify({
            schoolId: requiredData.schoolid,
            customerId: requiredData.customerid,
            subsidiary: requiredData.subsidiary,
            netsuiteCodeProfile: 1
        });
        setLoading(true);
        await ApiPostCall(`${adminCallNode}/billing/save-customer-subsidiary`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setRequiredFieldsPopup(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Data Updated Successfully."} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        DownloadCSV(requiredData.batchid, requiredData.customerid, requiredData.subsidiary, requiredData.schoolid, 2, requiredData.invoiceId);
                        if (GridTabs.BatchesTabs == 'active') {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 1, false)
                        } else {
                            GetAdminInvoiceData(SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, null, 2, false)
                        }
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });

    }
    async function GetNetSuiteData(batchid) {
        setLoading(true);
        await ApiGetCall(`${adminCallNode}/billing/netsuite-batch-data?batchId=${batchid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setNetSuiteData(responseRs.netsuite_parts_summary)
            }
        });
    }
    const netsuitemodalbody = (
        <div className='row px-2'>
            {NetSuiteData.length > 0 ?
                <>
                    <p className="mb-2 text-muted">This batch contains the following NetSuite/Internal SKUs:</p>
                    <ul className='ps-4'>
                        {NetSuiteData?.map((item, index) => (
                            <li key={index} className='pb-2'>
                                <span><b>Part : </b>{item.part_name}</span>
                                <br />
                                <span><b>SKU : </b>{item.netsuite_internal_sku}</span>
                                <br />
                                <span>
                                    <b>Qty : </b>
                                    {item.quantity}
                                </span>
                            </li>
                        ))}
                    </ul>
                </>
                :
                <label className='col-12 text-center'>No Data Found.</label>
            }
        </div>
    )
    const batchModalBody = (
        <>
            <div className="row mx-0 align-items-center">
                <div style={{ fontSize: '15px' }} className="mb-3">
                    <b>Batch No :</b> {BatchData.batch_order_num || "-"}
                </div>
                <div style={{ fontSize: '15px' }} className="mb-3">
                    <b>Created At :</b> {formatDateToMMDDYYYY(BatchData.billed_at) || "-"}
                </div>
                <div style={{ fontSize: '15px' }} className="mb-3">
                    <b>Created By :</b> {BatchData.created_by || "-"}
                </div>
            </div>
            <div id="FinalizeBillBatchModal" className="parent greyBox p-3 data-table-container" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                <div className="GridHeader">
                    <div className="row mx-0">
                        <div className='col-md-2'>Order No.</div>
                        <div className='col-md-4'>Item Name</div>
                        <div className='col-md-2'>Billed Qty</div>
                        <div className='col-md-4'>NetSuite SKU</div>
                    </div>
                </div>
                <div>

                    {BatchData.part_order_items && BatchData.part_order_items.length > 0 &&
                        BatchData.part_order_items.map((partDetail, index) => (
                            <div key={index} className="row OddEvenClass tableBorderHide mx-0">
                                <div className="text-wrap col-md-2">
                                    {partDetail.part_order_num || "-"}
                                </div>
                                <div className="text-wrap col-md-4">
                                    {partDetail.fulfilled_part_name || "-"}
                                </div>
                                <div className="col-md-2">
                                    {partDetail.billed_quantity || "-"}
                                </div>
                                <div className="test-wrap col-md-4">
                                    {partDetail.netsuite_internal_sku || "-"}
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    );

    const handlePartsBillingFile = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            setPartsOrderFile({ ...PartsOrderFile, fileName: file.name, fileBase64String: base64String })
        };
        reader.readAsDataURL(file);
    }

    const handleRowCheckChange = (e, item) => {
        const isChecked = e.target.checked;
        setSelectedBillingItems((prevState) =>
            isChecked
                ? prevState.some((device) => device.id === item.id)
                    ? prevState
                    : [...prevState, {
                        id: item.id,
                        school_name: item.school_name,
                        school_id: item.school_id,
                        item_name: item.item_name,
                    }]
                : prevState.filter((device) => device.id !== item.id)
        );
    };

    const handleSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        const pageItems = AllInvoiceData?.map((item) => ({
            id: item.id,
            school_name: item.school_name,
            school_id: item.school_id,
            item_name: item.item_name,
        }));

        if (isChecked) {
            const newItems = pageItems.filter(
                (item) => !selectedBillingItems.some((selected) => selected.id === item.id)
            );
            setSelectedBillingItems((prevState) => [...prevState, ...newItems]);
        } else {
            const pageIds = AllInvoiceData?.map((item) => item.id);
            const remainingDevices = selectedBillingItems.filter(
                (device) => !pageIds.includes(device.id)
            );
            setSelectedBillingItems(remainingDevices);
        }
    };

    function handleSorting(columnName) {
        GetPartOrdersWithBilling(partsOrderBillFlag, SchoolId, AdminInvoiceParams.searchString ? AdminInvoiceParams.searchString : null, columnName, sortingDetails.sortFlag, null, true)
    }
    const timeZoneAccess = hasRoleAccess(effectiveRole, RoleEnum.ALL_ADMINS);

    const currentPageType3Items = AllInvoiceData?.filter(item => item.type == 3);
    const currentPageSelectedCount = currentPageType3Items?.filter(item => selectedIdsAll.some(s => s.id === item.id)).length;

    return (
        <>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Billing"} handleSearch={handleSearchChange}
                loading={loading} Alerts={NewAlerts} showsearch={true} />
            <div className='row col-12 align-items-center pe-0 pt-2'>
                <div className="col-md-3 offset-md-9 py-1 pe-md-0">
                    <select value={SchoolId} onChange={(e) => { handleSetSchoolId(e.target.value) }}>
                        <option value="0">Filter by {organization}</option>
                        {AllSchool?.length == 0 && <optgroup label={no_organization_found}></optgroup>}
                        {AllSchool?.map((item, j) => (
                            <option value={item.id} key={j}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="GridBox mt-2 p-3">
                <div className="row align-items-center mb-3">
                    <div className="col-md-7 px-0">
                        <ul className="nav nav-tabs px-3">
                            <Tab isActive={GridTabs.BatchesTabs == 'active'}
                                label="Unbilled Batches" onClick={() => handleTabClick('current', 1)} col={'col-md-4'} />
                            <Tab isActive={GridTabs.PastBatchesTabs == 'active'}
                                label="Billed Batches" onClick={() => handleTabClick('past', 1)} col={'col-md-3'} />
                            {show_part_order_module && ExcludeVar && (
                                <Tab isActive={GridTabs.PartsOrdersTabs == 'active'}
                                    label="Parts Orders" onClick={() => handleTabClick('partsorders', 1)} col={'col-md-3'} />
                            )}
                        </ul>
                    </div>
                    <div className="col-md-5 text-end px-0 ">
                        {ExcludeVar && ShowCreateBatchButton == true && (
                            <>
                                <label className="BorderBtn ms-3 text-end mx-3 mt-0" onClick={() => { setDeliverBatchModal(true); }}>
                                    <FontAwesomeIcon icon={faPaperPlane} className="pe-2" />Send Invoice
                                </label>
                                <label className="BorderBtn ms-3 text-end mx-3 mt-0" onClick={() => { setMarkasPaidPopup(true); setMarkAsPaidFlag(1) }}>
                                    <FontAwesomeIcon icon={faDollarSign} className="pe-2" />Mark as Paid
                                </label>
                            </>
                        )}
                        {GridTabs.PartsOrdersTabs == "active" && selectedBillingItems.length > 0 &&
                            <label className="BorderBtn ms-3 text-end mx-3 mt-0" onClick={() => { setModals({ ...modals, showFinalizeBilling: true }); }}>
                                <img
                                    src='/images/FinalizeBill.svg'
                                    alt='FinalizeBill'
                                    className='img-fluid cursor-pointer pe-1'
                                    height={24}
                                    width={24}
                                />
                                Send to Billing
                            </label>
                        }
                    </div>
                    <div className='col-md-12 mt-2 ps-1 text-end'>
                        {GridTabs.BatchesTabs == 'active' || GridTabs.PastBatchesTabs == "active" ?
                            <span className='fw-600 blueText'>*Other Location</span> : <></>
                        }
                    </div>
                </div>
                {GridTabs.PartsOrdersTabs == 'active' && (
                    <div className='row align-items-center mb-3 ps-1'>
                        <div className='col-md-8 d-flex gap-3'>
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="partsOrderBilling" defaultChecked={partsOrderBillFlag == 1} onClick={() => handleTabClick('partsorders', 1)} />
                                <label className="form-check-label">Pending Parts</label>
                            </div>
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="partsOrderBilling" checked={partsOrderBillFlag == 2} onClick={() => handleTabClick('partsorders', 2)} />
                                <label className="form-check-label">Billed Batches</label>
                            </div>
                        </div>
                    </div>
                )}

                <div className="greyBox p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    {GridTabs.PartsOrdersTabs != 'active' ?
                                        <>
                                            {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_REPAIR_VAR) ?
                                                currentPageType3Items?.length != 0 ?
                                                    <th scope="col">
                                                        <input className='form-check-input' type="checkbox"
                                                            checked={currentPageSelectedCount === currentPageType3Items?.length}
                                                            onChange={(e) => handleHeaderCheckboxChange(e, "all")} />
                                                    </th>
                                                    : <th scope="col"></th>
                                                : <th scope="col"></th>}
                                            <th scope="col" title={`Sort by ${organization}`} className='cursor-pointer fw-600' onClick={(e) => handleSortClick('school_name')}>
                                                {organization}
                                                <img src="/images/sortbynew.svg" alt={`Sort by ${organization} Name`} className="img-fluid ps-2 sortbyClass" />
                                            </th>
                                            {columnNames?.map((item) => {
                                                let columnName = item.replace(/_/g, ' ');
                                                const transformedName = transformNameOfCol(columnName);
                                                if (!transformedName) return null;
                                                return (
                                                    item != "Location" && item != "Batch_Status" ?
                                                        <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                            {CamelCaseWithSpaces(transformedName)}
                                                            <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                        </th>
                                                        :
                                                        <th key={item} scope="col" className='fw-600'>
                                                            {CamelCaseWithSpaces(transformedName)}
                                                        </th>
                                                );
                                            })}
                                            {GridTabs.PastBatchesTabs == 'active' && (
                                                <th scope="col" className='fw-600'>Payment Status</th>
                                            )}
                                            <th scope="col" className='fw-600'>Delivery Date </th>
                                            <th scope="col" className='fw-600'>Finalized Date </th>
                                            <th scope="col" className='fw-600'>Signature </th>
                                            {onlyRepairTech ?
                                                <></> :
                                                <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action text-center' : ''}`}>Action
                                                    <img src="/images/EditHeaderIcon.svg" className="cursor-pointer  img-fluid ps-2" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} /></th>
                                            }
                                        </> :
                                        <>
                                            {partsOrderBillFlag == 1 && AllInvoiceData?.length != 0 &&
                                                <th scope='col'>
                                                    <input
                                                        className="form-check-input mt-1 cursor-pointer"
                                                        type="checkbox"
                                                        name="allSelect"
                                                        onChange={handleSelectAllChange}
                                                        checked={isAllChecked}
                                                    />
                                                </th>
                                            }
                                            {(partsOrderBillFlag == 1 ? [
                                                { key: "school_name", label: organization },
                                                { key: "part_order_num", label: "Order No." },
                                                { key: "item_name", label: "Item Name" },
                                                { key: "fulfilled_quantity", label: "Fulfilled Qty" },
                                                { key: "netsuite_internal_sku", label: "NetSuite SKU" },
                                                { key: "fulfilled_at", label: "Fulfilled Date" },
                                            ] : [
                                                { key: "school_name", label: organization },
                                                { key: "batch_order_num", label: "Batch No." },
                                                { key: "created_by", label: "Created By" },
                                                { key: "created_at", label: "Created Date" },
                                                { key: null, label: "Action", nosort: true },
                                            ]).map((col, index) => (
                                                <th key={index} scope="col" title={!col.nosort && `Sort by ${col.label}`} className="fw-600 cursor-pointer" onClick={() => col.key && handleSorting(col.key)}>
                                                    {col.label}
                                                    {!col.nosort &&
                                                        <img src="/images/sortbynew.svg" alt="sortbynew" className="img-fluid ps-2 sortbyClass" />
                                                    }
                                                </th>
                                            ))}
                                        </>
                                    }

                                </tr>
                            </thead>
                            <tbody>
                                {AllInvoiceData?.length != 0 ?
                                    AllInvoiceData?.map((item, i) => {
                                        return <tr key={i} className='OddEvenClass tableBorderHide'>
                                            {GridTabs.PartsOrdersTabs != 'active' ?
                                                <>
                                                    <td className="py-12">
                                                        {item.type == 3 ? (
                                                            <input className='form-check-input' type="checkbox"
                                                                checked={selectedIdsAll.some(obj => obj.id == item.id)}
                                                                onChange={(e) => handleCheckboxChange(e, "all", item.id, item.school_id, item.invoice_id, item.cheque_no)} batchid={item.id} />
                                                        ) : <></>}
                                                    </td>
                                                    <td className="py-12">
                                                        {item.school_name}
                                                    </td>
                                                    {columnNames?.map(header => (
                                                        <td className="py-12" key={header}>
                                                            {renderContentForColumn(header, item)}
                                                        </td>
                                                    ))}
                                                    {GridTabs.PastBatchesTabs == 'active' && (
                                                        <td className="py-12">
                                                            {item?.payment_status == 1 ? (
                                                                <span style={{ color: error_text_color }}>Pending</span>
                                                            ) : item?.payment_status == 3 ? (
                                                                <span style={{ color: succes_text_color }}>Success</span>
                                                            )
                                                                : (
                                                                    ExcludeVar ?
                                                                        <span className='cursor-pointer' style={{ color: inProgress_text_color }}
                                                                            onClick={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, sendreceipt: true, BatchId: item?.id, InvoiceNo: item?.invoice_id, TransactionId: item?.cheque_no, sendSchoolid: item?.school_id })}>
                                                                            <u>In Progress</u>
                                                                        </span>
                                                                        :
                                                                        <span >
                                                                            In Progress
                                                                        </span>
                                                                )}
                                                        </td>
                                                    )}
                                                    <td className='py-12'>
                                                        {item.delivered_date ? formatDateToMMDDYYYY(item.delivered_date) : '-'}
                                                    </td>
                                                    <td className='py-12'>
                                                        {item.finalized_date || '-'}
                                                    </td>
                                                    <td>
                                                        {ExcludeVar ?
                                                            <CustomFontAwesomeIcon icon={faPencilAlt} title="Signature" className="ps-2 cursor-pointer"
                                                                onClick={(e) => {
                                                                    setSignatureDataForPackedBy(item.batch_delivered_signature);
                                                                    setSignatureModal(true);
                                                                    setAdminInvoiceParams({ ...AdminInvoiceParams, BatchId: item.id, sendSchoolid: item.school_id })
                                                                }} />
                                                            :
                                                            <>-</>
                                                        }
                                                    </td>
                                                    {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_REPAIR_TECH) && (
                                                        <td className={`${isOverflowing ? 'sticky-action text-center' : ''}`}>
                                                            {/* if more icons are getting added increase the width */}
                                                            <div style={{ width: '140px' }}>
                                                                {(item.type == 3 || item.type == 5) &&
                                                                    ExcludeVar ?
                                                                    <label title='Mark as Paid'> <FontAwesomeIcon icon={faDollarSign} className="cursor-pointer"
                                                                        onClick={(e) => {
                                                                            setMarkAsPaidData({
                                                                                ...markAsPaidData, batchId: item.id,
                                                                                schoolId: item.school_id, invoiceId: item.invoice_id, chequeNo: item.cheque_no,
                                                                            })
                                                                            setMarkasPaidPopup(true);
                                                                            setMarkAsPaidFlag(2);

                                                                        }} /></label>
                                                                    : null
                                                                }
                                                                {item.type == 3 && (
                                                                    ExcludeVar ?
                                                                        <label title='Send Invoice'> <FontAwesomeIcon icon={faPaperPlane} className="pe-1 cursor-pointer" onClick={() => {
                                                                            setItemID(item.id); setFlagForItem(1); setDeliverBatchModal(true);
                                                                            setPaymentLink(''); setsendInvoiceDoc(''); setlinkFileName(''); setAdminInvoiceParams({ ...AdminInvoiceParams, sendSchoolid: item.school_id })
                                                                        }} /></label>
                                                                        :
                                                                        null
                                                                )}
                                                                <img src="/images/printlabelicon.svg" title="Show Packing List" style={{ height: "15px" }} className="img-fluid cursor-pointer pe-1" onClick={(e) => PrintPackingList(item.id)} />
                                                                <img src="/images/downloadPlan.svg" title="Download CSV" style={{ height: "13px" }} className="img-fluid cursor-pointer pe-1"
                                                                    onClick={(e) => DownloadCSV(item.id, item.customer_id, item.subsidiary, item.school_id, 1, item.invoice_code)} />
                                                                <img src="/images/InfoIcon.svg" style={{ height: "13px" }} title="Show NetSuite SKU" className="img-fluid cursor-pointer pe-1"
                                                                    onClick={(e) => { setNetSuiteModal(true); GetNetSuiteData(item.id) }} />
                                                                {item?.payment_status != 3 && (
                                                                    ExcludeVar ?
                                                                        <img src="/images/DeleteIcon.svg" title="Delete Batch" style={{ height: "15px" }} className="img-fluid cursor-pointer pe-1"
                                                                            onClick={(e) => { setDeletePopup(true); setAdminInvoiceParams({ ...AdminInvoiceParams, BatchId: item.id, sendSchoolid: item.school_id }) }} />
                                                                        :
                                                                        null
                                                                )}
                                                                {item?.invoice_pdf != null ?
                                                                    <img src="/images/previewpdficon.svg" className="pe-1 cursor-pointer" style={{ height: "15px" }} title="Preview Invoice" onClick={(e) => InvoicePdf(item?.invoice_pdf)} />
                                                                    : <>
                                                                    </>
                                                                }
                                                                {item?.shipstation_label ?
                                                                    <img src="/images/eye.png" className="cursor-pointer pe-1" title="Preview Shipping Label" style={{ height: "15px" }}
                                                                        onClick={(e) => ExtraDocument(item?.shipstation_label)} />
                                                                    :
                                                                    item?.label_url ?
                                                                        <img src="/images/eye.png" className="cursor-pointer pe-1" title="Preview Shipping Label" style={{ height: "15px" }}
                                                                            onClick={(e) => shipStationUrlTrack(item?.label_url)} />
                                                                        : <></>
                                                                }
                                                            </div>
                                                        </td>
                                                    )}
                                                </> :
                                                <>
                                                    {partsOrderBillFlag == 1 &&
                                                        <td className='py-12'>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input cursor-pointer"
                                                                onChange={(e) => handleRowCheckChange(e, item)}
                                                                checked={selectedBillingItems.some(device => device.id === item.id)}
                                                            />
                                                        </td>
                                                    }
                                                    <td className='py-12'>
                                                        {item.school_name || '-'}
                                                    </td>
                                                    {partsOrderBillFlag == 1 && (
                                                        <td className='py-12'>
                                                            {item.part_order_num || '-'}
                                                        </td>
                                                    )}
                                                    <td className='py-12'>
                                                        {partsOrderBillFlag == 1 ? item.item_name || '-' : item.batch_order_num || "-"}
                                                    </td>
                                                    <td className='py-12'>
                                                        {partsOrderBillFlag == 1 ? item.item_qty || '-' : item.created_by || "-"}
                                                    </td>
                                                    <td className='py-12'>
                                                        {partsOrderBillFlag == 1 ? item.netsuite_internal_sku || '-' : formatDateToUsaMMDDYYYY(item.created_at) || "-"}
                                                    </td>
                                                    {partsOrderBillFlag == 1 ?
                                                        <td className='py-12'>
                                                            {formatDateToMMDDYYYY(item.fulfilled_at) || '-'}
                                                        </td> :
                                                        <td className='py-12'>
                                                            <img
                                                                src='/images/InfoIcon.svg'
                                                                alt='InfoIcon'
                                                                title='Billed Batch Order Details'
                                                                className='img-fluid cursor-pointer pe-1'
                                                                onClick={() => {
                                                                    setModals({ ...modals, showBilledBatchOrder: true });
                                                                    GetBatchDetailsById(item.id)
                                                                }}
                                                            />
                                                        </td>
                                                    }
                                                </>
                                            }
                                        </tr>
                                    })
                                    :
                                    <tr><td colSpan={15} className="p-3 text-center"> No Record Found </td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {showPagination && (
                        <Pagination
                            activePage={currentPage}
                            totalItemsCount={pageRangeCount}
                            pageRangeDisplayed={15}
                            itemsCountPerPage={LimitForPagination}
                            onChange={(e) => setCurrentPage(e)}
                            color="primary"
                            lastPageText=""
                            firstPageText=""
                            itemClassFirst="MasterClass"
                            itemClassPrev="MasterClass"
                            itemClassNext="MasterClass"
                            itemClassLast="MasterClass"
                            hideFirstLastPages={true}
                        />
                    )}
                </div>
            </div>

            <Popup isshow={AdminInvoiceParams.sendreceipt} size={"md"} title={"Payment Details"}
                closePopup={(e) => setAdminInvoiceParams({ ...AdminInvoiceParams, sendreceipt: false, Notes: '' })}
                modalBody={sendreceiptBody} handleSave={SubmitInvoicePaymentCheck} visibleSaveBtn={true} btnText={"Submit"} />

            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deletePopup} size="xl" deletePart={DeleteBatch} DeleteShowClose={(e) => setDeletePopup(false)} />

            {
                CustomizationModal == true && (
                    <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} tabFlag={32} gridname={'Billing'} GetCall={() => ApiGetHeaders(32, setColumnNames)} />
                )
            }

            <Popup isshow={DeliverBatchModal} size={"md"} title={"Send Invoice & Deliver Batch"}
                closePopup={(e) => { setSelectedIdsAll([]); setPaymentLink(''); setsendInvoiceDoc(''); setlinkFileName(''); setDeliverBatchModal(false); }}
                modalBody={delievermodal} handleSave={DeliverBatchCall} visibleSaveBtn={true} btnText={"Send"} />

            {
                signatureModal == true && (
                    <Popup isshow={signatureModal} size={"md"} title={"Signature"}
                        closePopup={(e) => setSignatureModal(false)}
                        modalBody={signaturemodalbody} handleSave={SaveSignatureCall} visibleSaveBtn={true} btnText={"Save"} />
                )
            }


            <AlertPopup isshow={MarkasPaidPopup} img={'/images/greenInfo.svg'}
                headingtext={'Are you sure you want to mark this batch as paid?'} text={'All tickets included in this batch will be closed once marked as paid.'}
                cancelcall={(e) => setMarkasPaidPopup(false)}
                canceltext={"Cancel"} successtext={"Yes, Mark as Paid"}
                successcall={SaveMarkAsPaidBatch} btntype={'SaveBtn'}
            />

            <Popup isshow={RequiredFieldsPopup} size={"sm"} title={"Missing Required Information"}
                closePopup={(e) => { setRequiredFieldsPopup(false); }}
                modalBody={requiredfieldmodalbody} handleSave={SaveRequiredFields}
                visibleSaveBtn={true} btnText={"Save"} />

            <Popup isshow={NetSuiteModal} size={"md"} title={"NetSuite SKU Totals for Batch"}
                closePopup={(e) => { setNetSuiteData([]); setNetSuiteModal(false); }}
                modalBody={netsuitemodalbody} visibleSaveBtn={false} />

            <Popup
                isshow={modals.showBilledBatchOrder}
                size={"xl"}
                title={'Billed Batch Order Details'}
                closePopup={(e) => {
                    setModals({ ...modals, showBilledBatchOrder: false });
                    setBatchData([]);
                }}
                modalBody={batchModalBody}
                visibleSaveBtn={false}
            />
            <AlertPopup
                isshow={modals.showFinalizeBilling}
                img={'/images/greenInfo.svg'}
                headingtext={"Are you sure you'd like to proceed with billing for these parts?"}
                text={
                    <>
                        <div className='w-100 mb-3'>
                            All selected parts will be marked as billed.
                        </div>
                    </>
                }
                canceltext={"Cancel"}
                successtext={"Mark as Billed"}
                btntype={'SaveBtn'}
                successcall={FinalizeBatchBilling}
                cancelcall={(e) => {
                    setModals({ ...modals, showFinalizeBilling: false });
                    setSelectedBillingItems([]);
                    setPartsOrderFile({ ...PartsOrderFile, fileBase64String: "", fileName: "" })
                }}
            />
        </>
    )
}
